import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import './TS_EditableText.scss';
import { TS_Input, TS_TextArea } from '../TS_Input/index.js';
import { _className, stopPropagation, stringReplacer } from '../../utils/tools.js';
import { TS_ReadMore } from '../TS_ReadMore/index.js';
import { Button } from '../Button/Button.js';
class TS_EditableText_Base extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps) {
        const state = { ...this.state };
        state.original = nextProps.text;
        state.text ||= nextProps.text;
        state.isEditing = nextProps.editMode ?? false;
        state.parentRef ||= React.createRef();
        return state;
    }
    // ######################## Logic ########################
    onEnableEdit = () => {
        if (this.props.disableEdit || this.props.editMode !== undefined)
            return;
        this.setState({ text: this.state.original, isEditing: true });
    };
    onTextChange = (text) => {
        this.setState({ text });
    };
    onSubmitChanges = async (e) => {
        stopPropagation(e);
        const text = this.state.text;
        if (!this.props.onTextSaved)
            this.setState({ original: text, isEditing: false });
        await this.props.onTextSaved?.(text);
        this.setState({ original: text });
    };
    onCancelChanges = (e) => {
        if (e)
            stopPropagation(e);
        const original = this.state.original;
        if (!this.props.onCancel)
            this.setState({ text: original, isEditing: false });
        this.setState({ text: original });
        this.props.onCancel?.();
    };
    onResetChanges = (e) => {
        stopPropagation(e);
        const original = this.state.original;
        this.setState({ text: original });
    };
    onGeneralClick = (e) => {
        if (this.state.isEditing)
            stopPropagation(e);
    };
    handleBlur = (e) => {
        e.persist();
        //e.relatedTarget can be null if lost focus due to Enter
        if (e.relatedTarget === null || this.state.parentRef.current === e.relatedTarget || this.state.parentRef.current.contains(e.relatedTarget))
            return;
        this.onCancelChanges();
    };
    // ######################## Render ########################
    renderText = () => {
        const textToShow = this.props.shownText ?? this.state.original;
        return _jsxs("div", { className: 'ts-editable-text__text', onClick: this.onEnableEdit, children: [this.props.readMore && _jsx(TS_ReadMore, { collapsedHeight: this.props.readMoreCollapseHeight, text: textToShow }), !this.props.readMore && (this.props.highlightText
                    ? stringReplacer(textToShow, this.props.highlightText, (match, i) => _jsx("i", { className: 'ts-editable-text__highlight', children: match }, i))
                    : textToShow)] });
    };
    renderButton = {
        reset: () => _jsx(Button, { className: 'ts-editable-text__buttons__reset', onClick: this.onResetChanges, children: this.props.renderers?.resetButton || 'Reset' }),
        cancel: () => _jsx(Button, { className: 'ts-editable-text__buttons__cancel', onClick: this.onCancelChanges, children: this.props.renderers?.cancelButton || 'Cancel' }),
        accept: () => _jsx(Button, { className: 'ts-editable-text__buttons__save', onClick: this.onSubmitChanges, children: this.props.renderers?.saveButton || 'Save' })
    };
}
class TS_EditableText_TextArea extends TS_EditableText_Base {
    renderButtons = () => {
        return _jsxs("div", { className: 'ts-editable-text-area__buttons', children: [!this.props.hideReset && this.renderButton.reset(), this.renderButton.cancel(), this.renderButton.accept()] });
    };
    renderTextArea = () => {
        return _jsxs("div", { className: 'ts-editable-text-area__edit', children: [_jsx(TS_TextArea, { className: 'ts-editable-text-area__text-area', type: 'text', focus: true, value: this.state.isEditing ? this.state.text : this.props.shownText, onChange: this.onTextChange, onAccept: (val, e) => this.onSubmitChanges(e) }), this.renderButtons()] });
    };
    render() {
        const Renderer = this.state.isEditing ? this.renderTextArea : this.renderText;
        const className = _className('ts-editable-text-area', this.props.className);
        return _jsx("div", { className: className, onBlur: this.handleBlur, tabIndex: 1, onClick: this.onGeneralClick, ref: this.state.parentRef, children: _jsx(Renderer, {}) });
    }
}
class TS_EditableText_Input extends TS_EditableText_Base {
    renderInput = () => {
        return _jsxs("div", { className: 'ts-editable-text-input__edit', children: [this.renderButton.reset(), _jsx(TS_Input, { className: 'ts-editable-text-input__input', type: 'text', focus: true, value: this.state.text, onChange: this.onTextChange, onAccept: (val, e) => this.onSubmitChanges(e) }), _jsxs("div", { className: 'ts-editable-text-input__buttons', children: [this.renderButton.cancel(), this.renderButton.accept()] })] });
    };
    render() {
        const Renderer = this.state.isEditing ? this.renderInput : this.renderText;
        const className = _className('ts-editable-text-input', this.props.className);
        return _jsx("div", { className: className, tabIndex: 1, onBlur: this.handleBlur, onClick: this.onGeneralClick, ref: this.state.parentRef, children: _jsx(Renderer, {}) });
    }
}
export const TS_EditableText = {
    TextArea: TS_EditableText_TextArea,
    Input: TS_EditableText_Input,
};
//# sourceMappingURL=TS_EditableText.js.map